import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DictationButtonComponent } from '../dictation-button/dictation-button.component';
import { DictationDirective } from '../../directives/dictation.directive';

@Component({
    selector: 'app-dictation-demo',
    templateUrl: './dictation-demo.component.html',
    styleUrls: ['./dictation-demo.component.scss']
})
export class DictationDemoComponent implements OnInit {

    // Form controls for testing - Directive examples
    chiefComplaintControl = new FormControl('');
    clinicalNotesControl = new FormControl('');
    standaloneFieldControl = new FormControl('');

    // Form controls for testing - Original component examples
    patientNotesControl = new FormControl('', [Validators.required]);
    symptomsControl = new FormControl('');
    diagnosisControl = new FormControl('');

    demoForm = new FormGroup({
        // Directive examples
        chiefComplaint: this.chiefComplaintControl,
        clinicalNotes: this.clinicalNotesControl,
        standaloneField: this.standaloneFieldControl,
        // Original component examples
        patientNotes: this.patientNotesControl,
        symptoms: this.symptomsControl,
        diagnosis: this.diagnosisControl
    });

    // Track dictation events for debugging
    dictationLog: string[] = [];

    constructor() { }

    ngOnInit(): void {
    }

    onDictationReceived(text: string, fieldName: string) {
        this.dictationLog.unshift(`${new Date().toLocaleTimeString()} - ${fieldName}: "${text}"`);
        console.log('Dictation received:', { fieldName, text });
    }

    onRecordingStarted(fieldName: string) {
        this.dictationLog.unshift(`${new Date().toLocaleTimeString()} - Started recording for ${fieldName}`);
        console.log('Recording started for:', fieldName);
    }

    onRecordingStopped(fieldName: string) {
        this.dictationLog.unshift(`${new Date().toLocaleTimeString()} - Stopped recording for ${fieldName}`);
        console.log('Recording stopped for:', fieldName);
    }

    clearForm() {
        this.demoForm.reset();
        this.dictationLog = [];
    }

    clearLog() {
        this.dictationLog = [];
    }
}